/**
 * App类型，通过UA判断
 */
export enum appType {
  SinaFinanceAndroid = 15,
  SinaFinanceIOS = 30,
}

export enum ThsType {
  Hexin_Gphone = 'Hexin_Gphone',
  IHexin = 'IHexin',
}
